import axios from 'axios';
import { mystore } from '../store/mystore'
import keycloakStore from 'plugin-vuejs-keycloak'

//SIT
//const API_URL = 'https://devapi.bagicsit2.bajajallianz.com/';
//UAT
// const API_URL = 'https://api.bagicuat.bajajallianz.com/';
// const API_URL = 'http://cshportal.bagicuat.bajajallianz.com/';
//PreProd
//const API_URL = 'https://api.bagicpp.bajajallianz.com/';
//Prod
// const API_URL = 'https://webapi.bajajallianz.com/';
//Internal LB-SIT
//const API_URL = 'http://devcshportal.bagicsit2.bajajallianz.com/';
//Local
// const API_URL = 'http://localhost:8888/';
//Local AWS 
//const API_URL = 'http://65.0.180.130:9090/hospitalportal/';

const node_env = process.env.VUE_APP_ENV;

const prodAPI_URL = 'https://webapi.bajajgeneral.com/'
const uatAPI_URL = 'https://api.uat.bajajgeneral.com/'
const ppAPI_URL = 'https://htapi.preprod.bajajgeneral.com/'

const prodDOC_API_URL = 'https://docsoapapi.bajajgeneral.com/'
const uatDOC_API_URL = 'https://docsoapapi.uat.bajajgeneral.com/'
const ppDOC_API_URL = 'https://docsoapapi.preprod.bajajgeneral.com/'


//const API_URL = node_env == 'PROD' ? prodAPI_URL : node_env == 'UAT' ? uatAPI_URL : uatAPI_URL ;
const API_URL = node_env == 'PROD' ? prodAPI_URL : node_env == 'UAT' ? uatAPI_URL : node_env == 'PP' ? ppAPI_URL : uatAPI_URL ;
const DOC_API_URL = node_env == 'PROD' ? prodDOC_API_URL : node_env == 'UAT' ? uatDOC_API_URL : node_env == 'PP' ? ppDOC_API_URL : uatDOC_API_URL ;
const LOGIN_API_URL = '';

const headers = {
    'Content-Type': 'application/json',
    'auth': 'Bearer ' + localStorage.getItem("token"),
};
const headers_form = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
//const headersWithoutAuth = {
//   'Content-Type': 'application/json'
//};
export class HttpService {
    myStore = mystore;
    constructor() {
    }
    httpPostAPI(context, input) {
        let authDetails = keycloakStore.state.security.auth;
        //myStore.setLoading(true);
        //myStore.state.token=this.$store.state.token
        if (authDetails.authenticated) {
            localStorage.setItem("access_token", authDetails.token);
            //this.$store.commit("token", authDetails.token);
            this.myStore.state.token = authDetails.token
        } else {
            console.log("false")
            console.log(JSON.stringify(authDetails));
        }
        var date = new Date();
        var uniqueDateTime = date.getTime();
        headers.auth = "Bearer " + this.myStore.state.token;
        headers.corelationid = "CID-" + uniqueDateTime;
        headers.businesscorelationid = "BID- " + uniqueDateTime;
        const url = `${API_URL}${context}`;
        delete axios.defaults.headers.common["Authorization"];
        return axios.post(url, input, { headers }).then(response => response.data);
    }
    httpGetAPI(context) {
        const url = `${API_URL}${context}`;
        return axios.get(url).then(response => response.data);
    }
    httpPostLoginAPI(user) {
        let input = "username=" + user.username + "&password=" + btoa(user.password);
        //var myStore = mystore
        //myStore.setLoading(true);
        const url = `${LOGIN_API_URL}`;
        return axios.post(url, input, { headers_form }).then(response => response.data);

    }
    httpPostWithoutTokenAPI(context, input) {
        const url = `${API_URL}${context}`;
        // const url = "http://localhost:8888/"+context;
        var date = new Date();
        var uniqueDateTime = date.getTime();
        delete axios.defaults.headers.common["Authorization"];
        headers.auth = "Bearer eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJCaGNSY1UwcVNtTENJeEd2Y29kTHl4X28zenVpSW5ZRXBnc2lEbTZhblFrIn0.eyJ";
        headers.corelationid = "CID-" + uniqueDateTime;
        headers.businesscorelationid = "BID- " + uniqueDateTime;
        return axios.post(url, input, { headers }).then(response => response.data);

    }

        httpPostDocAPI(context, input) {
        let authDetails = keycloakStore.state.security.auth;
        if (authDetails.authenticated) {
            localStorage.setItem("access_token", authDetails.token);
            this.myStore.state.token = authDetails.token
        } else {
            console.log("false")
            console.log(JSON.stringify(authDetails));
        }
        var date = new Date();
        var uniqueDateTime = date.getTime();
        headers.auth = "Bearer " + this.myStore.state.token;
        headers.corelationid = "CID-" + uniqueDateTime;
        headers.businesscorelationid = "BID- " + uniqueDateTime;
        const url = `${DOC_API_URL}${context}`;
        delete axios.defaults.headers.common["Authorization"];
        return axios.post(url, input, { headers, timeout: 5000000 }).then(response => response.data);
    }

    httpPostWithoutTokenAPIUrk(url) {
        delete axios.defaults.headers.common["Authorization"];
        return axios.post(url, {}, {}).then(response => response.data);
    }

}